module.exports = __webpack_public_path__ + "fonts/Raleway-Italic.3a8327dc.ttf";